// 引入ECharts CDN (在HTML中添加)
// <script src="https://cdn.jsdelivr.net/npm/echarts@5.4.3/dist/echarts.min.js"></script>

(function() {
  'use strict';

  let nameData = [];

  function dataInit(name) {
    return window.apiRequest.get(`/v1/baby_name/historical_data?name=${name}`).then(data => {
      console.log(data);
      nameData = data.data;
    });
  }

  let currentGender = 'F';
  let chart = null;

  function initCurrentGender() {
    const curActiveTab = document.querySelector('.patpat-blog-tab-active');
    if (curActiveTab) {
      currentGender = curActiveTab.getAttribute('data-gender');
    }
  }

  // 初始化图表
  function initChart() {

    const chartDom = document.getElementById('popularityChart');
    if (!chartDom) {
      console.error('Chart container not found');
      return;
    }

    // 检查ECharts是否已加载
    if (typeof echarts === 'undefined') {
      console.error('ECharts library not loaded. Please include ECharts CDN in HTML.');
      return;
    }

    chart = echarts.init(chartDom);
    updateChart(currentGender);
  }

  // 更新图表
  function updateChart(gender) {
    if (!chart) return;

    const usData = (gender === 'F' ? nameData.fData : nameData.mData) || [];

    const lineColor = gender === 'F' ? '#F1A045' : '#5071FD'
    const areaSColor = gender === 'F' ? 'rgba(241, 160, 69, 0.2)' : 'rgba(80, 113, 253,0.2)'
    const areaEColor = gender === 'F' ? 'rgba(241, 160, 69, 1)' : 'rgba(80, 113, 253,1)'
    

    const option = {
      backgroundColor: 'transparent',
      grid: {
        left: '50px',
        right: '20px',
        top: '40px',
        bottom: '40px'
      },
      xAxis: {
        type: 'category',
        data: usData.map(item => item.year),
        boundaryGap: false,
        axisLine: {
          lineStyle: {
            color: '#ddd'
          }
        },
        axisLabel: {
          color: '#666',
          fontSize: 12,
          interval: 'auto',
          rotate: 0
        }
      },
      yAxis: {
        type: 'value',
        inverse: false, // 排名越小越靠上
        axisLine: {
          show: false
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#666',
          fontSize: 12
        },
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        }
      },
      tooltip: {
        trigger: 'axis',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: '#ddd',
        borderWidth: 1,
        textStyle: {
          color: '#333'
        },
        formatter: function(params) {
          let result = params[0].name + '<br/>';
          params.forEach(item => {
            if (item.value !== null) {
              result += item.marker + ' ' + item.seriesName + ': #' + item.value + '<br/>';
            }
          });
          return result;
        }
      },
      series: [
        {
          name: 'United States',
          type: 'line',
          data: usData.map(item => item.useNum),
          smooth: true,
          symbol: 'circle',
          symbolSize: 8,
          lineStyle: {
            color: lineColor,
            width: 3
          },
          itemStyle: {
            color: lineColor,
            borderColor: '#fff',
            borderWidth: 2
          },
          areaStyle: {
            color: {
              type: 'linear',
              x: 0,
              y: 0,
              x2: 0,
              y2: 1,
              colorStops: [
                {
                  offset: 0,
                  color: areaSColor
                },
                {
                  offset: 1,
                  color: areaEColor
                }
              ]
            }
          },
          connectNulls: false
        }
      ]
    };

    chart.setOption(option);
  }

  // 性别切换
  function setupGenderToggle() {
    const tabs = document.querySelectorAll('.patpat-blog-tab');
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        // 移除所有active类
        tabs.forEach(t => t.classList.remove('patpat-blog-tab-active'));
        // 添加active到当前标签
        this.classList.add('patpat-blog-tab-active');
        
        // 获取性别
        currentGender = this.getAttribute('data-gender');
        
        // 更新图表标题
        const genderText = currentGender === 'F' ? 'Girl' : 'Boy';
        const chartTitle = document.querySelector('.patpat-blog-chart-title');
        if (chartTitle) {
          chartTitle.textContent = 'Popularity of Adalyn - ' + genderText;
        }

        updateYearSelector();
        
        // 更新图表
        updateChart(currentGender);
        
        // 更新统计数据
        updateStats(currentGender);
      });
    });
  }

  function updateYearSelector() {
    const yearSelector = document.getElementById('yearSelector');
    if (yearSelector) {
      const genderData = currentGender === 'F' ? nameData.fData : nameData.mData;
      yearSelector.innerHTML = genderData.reduce((res, item) => {
        res.unshift(`<option value="${item.year}">${item.year}</option>`);
        return res;
      },[]).join('');
    }
  }

  // 年份选择器
  function setupYearSelector() {
    const yearSelector = document.getElementById('yearSelector');
    
    if (yearSelector) {
      updateYearSelector()
      yearSelector.addEventListener('change', function() {
        const selectedYear = this.value;
        updateStats(currentGender, selectedYear);
      });
    }
  }

  // 更新统计数据
  function updateStats(gender, year) {
    const yearSelector = document.getElementById('yearSelector');
    const selectedYear = year || (yearSelector ? yearSelector.value : '2024');
    const prevYear = String(parseInt(selectedYear) - 1);
    
    // 这里应该根据实际数据更新
    // 示例：更新当前排名和趋势
    const currentRankDisplay = document.getElementById('currentRankDisplay');
    const currentYearDisplay = document.getElementById('currentYearDisplay');
    const rankChangeDisplay = document.getElementById('rankChangeDisplay');
    const prevYearDisplay = document.getElementById('prevYearDisplay');
    const trendIconContainer = document.getElementById('trendIconContainer');

    const genderData = gender === 'F' ? nameData.fData : nameData.mData;
    const currentYearData = genderData.find(item => item.year == selectedYear);
    const prevYearData = genderData.find(item => item.year == prevYear);


    if (currentRankDisplay && currentYearData) currentRankDisplay.textContent = '#' + currentYearData.useRank;
    if (currentYearDisplay) currentYearDisplay.textContent = selectedYear;
    if (rankChangeDisplay && currentYearData && prevYearData) rankChangeDisplay.textContent = prevYearData.useRank - currentYearData.useRank;
    if (prevYearDisplay) prevYearDisplay.textContent = prevYear;
    
    // 更新趋势图标（向下表示排名下降）
    if (trendIconContainer) {
      trendIconContainer.innerHTML = ''
      // `
      //   <svg width="40" height="41" viewBox="0 0 40 41" fill="none" xmlns="http://www.w3.org/2000/svg">
      //     <path d="M20 37.1667C29.2047 37.1667 36.6666 29.7048 36.6666 20.5C36.6666 11.2953 29.2047 3.83337 20 3.83337C10.7952 3.83337 3.33331 11.2953 3.33331 20.5C3.33331 29.7048 10.7952 37.1667 20 37.1667Z" stroke="black" stroke-width="2" stroke-linejoin="round"/>
      //     <path d="M20 13.4166V28.4166" stroke="#FD7B6B" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
      //     <path d="M12.5 20.9166L20 28.4166L27.5 20.9166" stroke="#FD7B6B" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
      //   </svg>
      // `;
    }
  }

  // 响应式处理
  function handleResize() {
    if (chart) {
      chart.resize();
    }
  }

  function toLinkInit() {
    // 获取所有目录链接
    const tocLinks = document.querySelectorAll('.patpat-toc__link');
    
    tocLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        e.preventDefault(); // 阻止默认锚点跳转
        
        const targetId = this.getAttribute('href').substring(1,2); // 获取目标 id（去掉 #）
        const targetElement = document.querySelectorAll('.patpat-blog-section-title')[targetId-1];
        
        if (targetElement) {
          // 平滑滚动到目标元素
          targetElement.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });

    // 获取所有名字收藏图标
    const namePillIcons = document.querySelectorAll('.patpat-blog-name-pill-icon');
    
    namePillIcons.forEach(icon => {
      icon.addEventListener('click', function() {
        // 切换 is-active class
        this.classList.toggle('is-active');
      });
    });
  }

  // 页面加载完成后初始化
  function init() {
    // 确保DOM已加载
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        initCurrentGender();
        initChart();
        setupGenderToggle();
        setupYearSelector();
        toLinkInit();
        updateStats(currentGender);
      });
    } else {
      initCurrentGender();
      initChart();
      setupGenderToggle();
      setupYearSelector();
      toLinkInit();
      updateStats(currentGender);
    }

    // 监听窗口大小变化
    window.addEventListener('resize', handleResize);
  }
  const curName = window.location.pathname.split('/').slice(-1)[0]
  dataInit(curName).then(() => {
    // 启动应用
    init();
  });

  const ruffdom = document.querySelector('#ruffruff-table-of-contents')
  if(ruffdom) {
    ruffdom.style = 'display: none !important';
  }


  

})();

